function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from "react";
import PropTypes from "prop-types";
import StepScore from "./question-step-content-sections/step-score";
import StepResult from "./question-step-content-sections/step-result";
import StepLearnMore from "./question-step-content-sections/step-learn-more";
import StepQuestion from "./question-step-content-sections/step-question";
import StepAnswers from "./question-step-content-sections/step-answers";
var StepContent = /*#__PURE__*/function (_Component) {
  function StepContent(props) {
    var _this;
    _classCallCheck(this, StepContent);
    _this = _callSuper(this, StepContent, [props]);
    _this.state = {
      wasClicked: false,
      correctResult: false,
      learnMore: false
    };
    return _this;
  }
  _inherits(StepContent, _Component);
  return _createClass(StepContent, [{
    key: "updatePoints",
    value: function updatePoints(shouldTriggerPoints) {
      if (this.state.wasClicked) {
        return;
      }
      this.setState({
        wasClicked: true
      });
      if (shouldTriggerPoints) {
        this.setState({
          correctResult: true
        });
      } else {
        this.setState({
          correctResult: false
        });
      }
    }
  }, {
    key: "showLearnMore",
    value: function showLearnMore() {
      this.setState(function (prevState) {
        return {
          learnMore: !prevState.learnMore
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        content = _this$props.content,
        onNextClick = _this$props.onNextClick,
        onUpdatePoints = _this$props.onUpdatePoints,
        points = _this$props.points,
        score = _this$props.score,
        stepsNumber = _this$props.stepsNumber,
        currentStepIndex = _this$props.currentStepIndex,
        isDesktop = _this$props.isDesktop;
      var _this$state = this.state,
        wasClicked = _this$state.wasClicked,
        correctResult = _this$state.correctResult,
        learnMore = _this$state.learnMore;
      var desktopLayout = /*#__PURE__*/React.createElement("div", {
        className: "step__content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "step__container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "step__main"
      }, /*#__PURE__*/React.createElement(StepQuestion, {
        stepsNumber: stepsNumber,
        content: content
      }), wasClicked && /*#__PURE__*/React.createElement(StepResult, {
        correctResult: correctResult
      }), wasClicked && /*#__PURE__*/React.createElement(StepLearnMore, {
        content: content,
        learnMore: learnMore,
        showLearnMore: function showLearnMore(e) {
          return _this2.showLearnMore(e);
        },
        isDesktop: isDesktop
      }), /*#__PURE__*/React.createElement(StepAnswers, {
        content: content,
        wasClicked: wasClicked,
        points: points,
        onUpdatePoints: onUpdatePoints,
        updatePoints: function updatePoints(e) {
          return _this2.updatePoints(e);
        }
      })), /*#__PURE__*/React.createElement(StepScore, {
        points: points,
        score: score,
        stepsNumber: stepsNumber,
        currentStepIndex: currentStepIndex,
        wasClicked: wasClicked
      })), /*#__PURE__*/React.createElement("div", {
        className: "step__buttons"
      }, /*#__PURE__*/React.createElement("button", {
        onClick: function onClick(e) {
          e.preventDefault();
          onNextClick();
        },
        disabled: !wasClicked,
        dangerouslySetInnerHTML: {
          __html: content.NextButtonLabel
        }
      })));
      var mobileLayout = /*#__PURE__*/React.createElement("div", {
        className: "step__content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "step__container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "step__main"
      }, /*#__PURE__*/React.createElement(StepQuestion, {
        stepsNumber: stepsNumber,
        content: content
      }), wasClicked && /*#__PURE__*/React.createElement(StepResult, {
        correctResult: correctResult
      }), /*#__PURE__*/React.createElement(StepAnswers, {
        content: content,
        wasClicked: wasClicked,
        points: points,
        onUpdatePoints: onUpdatePoints,
        updatePoints: function updatePoints(e) {
          return _this2.updatePoints(e);
        }
      }), wasClicked && /*#__PURE__*/React.createElement(StepLearnMore, {
        content: content,
        learnMore: learnMore,
        showLearnMore: function showLearnMore(e) {
          return _this2.showLearnMore(e);
        },
        isDesktop: isDesktop
      }))), /*#__PURE__*/React.createElement("div", {
        className: "step__buttons"
      }, /*#__PURE__*/React.createElement(StepScore, {
        points: points,
        score: score,
        stepsNumber: stepsNumber,
        currentStepIndex: currentStepIndex,
        wasClicked: wasClicked
      }), /*#__PURE__*/React.createElement("button", {
        onClick: function onClick(e) {
          e.preventDefault();
          onNextClick();
        },
        disabled: !wasClicked,
        dangerouslySetInnerHTML: {
          __html: content.NextButtonLabel
        }
      })));
      return isDesktop ? desktopLayout : mobileLayout;
    }
  }]);
}(Component);
StepContent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  onNextClick: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool.isRequired
};
export default StepContent;